module.exports = "<navigation></navigation>\n<router-outlet></router-outlet>"